module.exports = __webpack_public_path__ + "img/SU.fe1a63dc.png";